import {SxProps, Theme} from "@mui/material";
import {Colors} from "@bounce/shared/ui";

export const partnerInfoHeaderContainerStyle: SxProps<Theme> = {
  width: "100%",
  padding: "16px",
  gap: "6px",
  backgroundColor: Colors.bw.white,
  border: `1px solid ${Colors.tertiary._300}`,
  borderRadius: "8px",
  transition: "background-color 0.2s ease",
  boxSizing: "border-box",
  "&:hover": {
    backgroundColor: Colors.secondary._100,
  },
};

export const partnerInfoLogoContainerStyle: SxProps<Theme> = {
  width: "44px",
  height: "44px",
  borderRadius: "8px",
  backgroundColor: "#faf4ee",
  border: `1px solid ${Colors.tertiary._400}`,
  overflow: "hidden",
};

export const partnerInfoNameStyle: SxProps<Theme> = {
  color: Colors.tertiary._800,
  lineHeight: "22px",
};

export const partnerInfoTypeStyle: SxProps<Theme> = {
  color: Colors.tertiary._600,
  lineHeight: "22px",
};
